import { useReducer } from "react"

export default () => useReducer(value => (value + 1) % 10, 0)
